import { DateTimeStr, ScheduleStatusReport } from '@mi-front/core';
import { apiClient } from '../../../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../../../core/reports/types';
import { ScheduleStatusSpotForm } from './ScheduleStatusSpotForm';
import { ScheduleStatusSpotResult } from './ScheduleStatusSpotResult';
import { Station } from '@app/core/types/stations';

interface Props {
  readonly station: Station;
}

export type ScheduleStatusSpotReport = ReportType<
  { from: DateTimeStr; to: DateTimeStr; customId: string },
  ScheduleStatusReport
>;

export function ScheduleStatusSpotView(p: Props) {
  const tz = useTimezone();

  return (
    <ReportView<ScheduleStatusSpotReport>
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        customId: '',
      }}
      runOnLoad
      download={false}
      queryParamsTransform={{
        customId: {
          parse: (input) => input,
          serialize: (input) => input.replace(/\s/g, ''),
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.stationReportsScheduleStatusAds(p.station.slug, {
          from: values.from,
          to: values.to,
          customId: values.customId || undefined,
        });
      }}
      Form={ScheduleStatusSpotForm}
      Result={ScheduleStatusSpotResult}
    />
  );
}
